import Report from "./../../../views/appointments/AppointmentsQuery"
import Detail from "./../../../views/appointments/AppointmentsDetail"
export const appointments = {
    path: '/appointments',
    name: 'Appointments',
    component: Report
  }
  export const detail = {
    path: '/detail/:id',
    name: 'Detail',
    component: Detail
  }


// WEBPACK FOOTER //
// ./src/router/index/appointments/index.js